export const S3 = 's3';
export const GCLOUD = 'gcloud';
export const AZURE = 'azure';

export const S3_LABEL = 'Amazon S3';
export const GCLOUD_LABEL = 'Google Cloud Storage';
export const AZURE_LABEL = 'Azure Blob Storage';

const customerDrivers = [
  {
    text: '-----',
    value: '',
  },
  {
    text: S3_LABEL,
    value: S3,
  },
  {
    text: GCLOUD_LABEL,
    value: GCLOUD,
  },
  {
    text: AZURE_LABEL,
    value: AZURE,
  },
];

export default customerDrivers;
